import React from "react";
import { Tabs } from "@heroui/react";
import { useLocale } from "../context/LocaleContext";
import { navigatePortal } from "../lib/navigation";

const SECTIONS = [
  { id: "overview", path: "/portal/overview", labelKey: "nav.overview" },
  { id: "onboarding", path: "/portal/onboarding", labelKey: "nav.onboarding" },
  { id: "withdrawals", path: "/portal/withdrawals", labelKey: "nav.withdrawals" },
  { id: "guarantees", path: "/portal/guarantees", labelKey: "nav.guarantees" },
  { id: "ai-labels", path: "/portal/ai-labels", labelKey: "nav.aiLabels" },
  { id: "emails", path: "/portal/emails", labelKey: "nav.emails" },
  { id: "extension-texts", path: "/portal/extension-texts", labelKey: "nav.extensionTexts" },
  { id: "settings", path: "/portal/settings", labelKey: "nav.settings" },
  { id: "exports", path: "/portal/exports", labelKey: "nav.exports" },
  { id: "billing", path: "/portal/billing", labelKey: "nav.billing" },
  { id: "help", path: "/portal/help", labelKey: "nav.help" }
];

function activeSectionId(path) {
  if (path.includes("/portal/withdrawals")) return "withdrawals";
  if (path.includes("/portal/guarantees")) return "guarantees";
  if (path.includes("/portal/ai-labels")) return "ai-labels";
  if (path === "/portal/overview" || path === "/portal/overview/") return "overview";
  const match = SECTIONS.find((section) => path.includes(section.path));
  return match?.id || "overview";
}

export function PortalSectionTabs({ path }) {
  const { t } = useLocale();
  const selectedKey = activeSectionId(path);

  return (
    <div className="portal-section-tabs">
      <Tabs
        className="w-full text-center"
        selectedKey={selectedKey}
        onSelectionChange={(key) => {
          const section = SECTIONS.find((item) => item.id === key);
          if (section) navigatePortal(section.path);
        }}
      >
        <Tabs.ListContainer>
          <Tabs.List
            aria-label="Portal sections"
            className="w-fit *:h-6 *:w-fit *:px-3 *:text-sm *:font-normal *:data-[selected=true]:text-accent-foreground"
          >
            {SECTIONS.map((section) => (
              <Tabs.Tab key={section.id} id={section.id}>
                {t(section.labelKey)}
                <Tabs.Indicator className="bg-accent" />
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Tabs.ListContainer>
      </Tabs>
    </div>
  );
}
